import { render, staticRenderFns } from "./suitch-enermonv1.vue?vue&type=template&id=6cf1a2b4&"
import script from "./suitch-enermonv1.vue?vue&type=script&lang=js&"
export * from "./suitch-enermonv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports